/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { FC } from "react";

export const LiveCommercePaymentMethodConfirm: FC<{
  isDarkModeEnabled: boolean;
  paymentMethodValue: string;
  onClick: () => void;
}> = ({ isDarkModeEnabled, paymentMethodValue, onClick }) => {
  const { t } = useI18n();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <p
        css={css`
          color: ${isDarkModeEnabled ? "#fff" : "#000"};
          font-size: 16px;
          font-weight: 700;
        `}
      >
        {t("streaming.commerceCart.payment")}
      </p>

      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr max-content;
          align-items: center;
          gap: 16px;
          padding: 16px 16px 12px;
          color: ${isDarkModeEnabled ? "#fff" : "#000"};
          background-color: ${isDarkModeEnabled ? "#141414" : "#f5f5f5"};
          border: 1px solid;
          border-color: ${isDarkModeEnabled
            ? "rgba(255, 255, 255, 0.2)"
            : "#e0e0e0"};
        `}
      >
        <p
          css={css`
            font-size: 14px;
            font-weight: 700;
          `}
        >
          {paymentMethodValue}
        </p>

        <button
          type={"button"}
          css={css`
            color: ${isDarkModeEnabled ? "#fff" : "#000"};
            font-size: 14px;
            font-weight: 700;
            border: none;
            background-color: transparent;
            cursor: pointer;
          `}
          onClick={onClick}
        >
          {t("streaming.commerceCart.edit")}
        </button>
      </div>
    </div>
  );
};
